import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  typography: {
    button: {
      textTransform: 'none'
    }
  },
  palette: {
    primary: {
      main: '#5D6EBE',
    },
    secondary: {
      main: '#808080',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;